var version = require("./version")

module.exports = VirtualText

function VirtualText(text) {
    this.text = String(text)
}

VirtualText.prototype.version = version
VirtualText.prototype.type = "VirtualText"



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/vtext.js
// module id = 201
// module chunks = 0